// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__mfPGe","col":"styles_col__3GX30","fulfillmentStatus":"styles_fulfillmentStatus__3axoG","emailCol":"styles_emailCol__3JV_t"};